module.exports = __webpack_public_path__ + "img/s03_p06.8d3d288c.jpg";